import React, { useEffect, useRef, useState } from "react";

const HighLevelArchitectureSection = ({ image }) => {
  const sectionRef = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="high-level-architecture-section py-5" ref={sectionRef}>
      <div className="container text-center overflow-hidden">
        <h2 className="fw-bold text-dark mb-4">High Level Architecture</h2>
        <img
          src={image}
          alt="High Level Architecture"
          className={`img-fluid rounded ${visible ? "slide-in-left-hla" : ""}`}
          style={{
            maxWidth: "100%",
            opacity: visible ? 1 : 0,
            transition: "all 0.8s ease-out",
          }}
        />
      </div>
    </section>
  );
};

export default HighLevelArchitectureSection;
